"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toColor = toColor;

var _toValidHEX = require("../toValidHEX");

var _hex2rgb = require("../hex2rgb");

var _rgb2hsb = require("../rgb2hsb");

var _rgb2hex = require("../rgb2hex");

var _hsb2rgb = require("../hsb2rgb");

function toColor(format, color) {
  var hex;
  var rgb;
  var hsb;

  if (format === "hex") {
    var newColor = color;
    hex = (0, _toValidHEX.toValidHEX)(newColor);
    rgb = (0, _hex2rgb.hex2rgb)(hex);
    hsb = (0, _rgb2hsb.rgb2hsb)(rgb.r, rgb.g, rgb.b);
  } else if (format === "rgb") {
    var _newColor = color;
    rgb = _newColor;
    hex = (0, _rgb2hex.rgb2hex)(rgb.r, rgb.g, rgb.b);
    hsb = (0, _rgb2hsb.rgb2hsb)(rgb.r, rgb.g, rgb.b);
  } else if (format === "hsb") {
    var _newColor2 = color;
    hsb = _newColor2;
    rgb = (0, _hsb2rgb.hsb2rgb)(hsb.h, hsb.s, hsb.b);
    hex = (0, _rgb2hex.rgb2hex)(rgb.r, rgb.g, rgb.b);
  } else {
    hex = "#000000";
    rgb = (0, _hex2rgb.hex2rgb)(hex);
    hsb = (0, _rgb2hsb.rgb2hsb)(rgb.r, rgb.g, rgb.b);
  }

  return {
    hex: hex,
    rgb: rgb,
    hsb: hsb
  };
}